import React, { Component, Fragment } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import Header from './Header';
import Payments from './Payments';
import Voucher from './Voucher';
import Details from './Details';
import Items from './Items';
import Bills from './Bills';

const QUERY = gql`
query portalOrder($operatorId: String!, $orderId: ID!) {
    portalOrder(operatorId: $operatorId, id: $orderId) {
      id
      order {
        id
        orderOrigin
        createdAt
        externalOrderNumber
        totalAmount
        protocol
        baseAmount
        orderState
        promotionalTicket {
          code
          title
          description
          isPercent
          discount
        }
        orderItems {
          id
          title
          description
          amount
        }
        customer {
          name
          email
          phone
          licensePlate
          renavam
          document
        }
        orderStatus
        voucher {
          amount
          code
          expirationDate
        }
        payments {
          amount
          installments
          installmentsAmount
          createdAt
          nsu
          paymentStatus
          paymentType
          card {
            holder
            brand
            trunc
          }
        }
        bills {
          id
          createdAt
          barcode
          amount
          dueDate
          settledAt
          settled
        }
      }
      establishment {
        title
      }

      portalUser {
        user {
          name
        }
      }
      terminal {
        logicalNumber
      }
      baseAmount
    }
  }
`;

class OrderDetails extends Component {
    render() {
        const { operatorId } = this.props;
        const orderId = this.props.match.params.id;
        return (
            <Query query={QUERY} variables={{ operatorId, orderId }}>
                {({ loading, error, data }) => {
                    if (loading) return 'Loading...';
                    if (error) {
                        return (
                            <div className="rounded-0 alert alert-warning m-0">
                                Não foi possível carregar os detalhes da venda.
                            </div>
                        );
                    }
                    const { portalOrder } = data;
                    const { order, establishment, terminal } = portalOrder;
                    const portalUser = portalOrder.portalUser || {};
                    const { protocol, totalAmount, baseAmount,
                      externalOrderNumber, payments, createdAt, customer,
                      orderItems, orderStatus, orderState, bills, voucher,
                    } = order;
                    return (
                        <Fragment>
                            <Header
                                protocol={protocol}
                                finished={(orderStatus === 'CHECKOUT_SUCCESS')}
                                order={order}

                            />
                            <div className="container-fluid mt--6">
                                <Details
                                    updatedBaseAmount={portalOrder.baseAmount}
                                    totalAmount={totalAmount}
                                    baseAmount={baseAmount}
                                    establishment={establishment}
                                    terminal={terminal}
                                    seller={portalUser.user || {}}
                                    externalOrderNumber={externalOrderNumber}
                                    createdAt={createdAt}
                                    customer={customer}
                                    status={orderStatus}
                                    state={orderState}
                                />
                              {voucher ?
                                <Voucher voucher={voucher} />
                                :
                                <Payments payments={payments} />
                              }
                              <Items items={orderItems} />
                              <Bills bills={bills} />
                            </div>
                        </Fragment>
                    );
                }}
            </Query>
        );
    }
}

const mapStateToProps = (state) => ({
  operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(OrderDetails);



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/index.js